import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

const modules = [
  require('./auth'),
  require('./bnpl'),
  require('./choice'),
  require('./device'),
  require('./env'),
  require('./errors'),
  require('./time'),
  require('./store'),
  require('./business'),
  require('./signup'),
  require('./terms'),
  require('./overlay'),
  require('./product'),
  require('./mall'),
  require('./meta'),
  require('./code/bank'),
  require('./contract'),
  require('./wholesaler'),
  require('./news'),
  require('./mallLimits'),
  require('./plans'),
  require('./bankMaintenance'),
  require('./ui/ui'),
  require('./ui/header'),
  require('./ui/toast'),
].reduce((map, module) => {
  const d = module.default
  map[d.name] = d
  return map
}, {})

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  // plugins: [
  //   createPersistedState({
  //     paths: ['signup'],
  //   }),
  // ],
})
